import React from "react";
import Reveal from "./Reveal";
import { elevation } from "../mock";

const Elevation = () => {
  return (
    <section className="bg-neg-beige py-20 lg:py-28">
      <div className="mx-auto max-w-6xl px-6 lg:px-10">
        <Reveal>
          <div className="flex flex-col items-center">
            <h2 className="font-display text-neg-navy text-4xl sm:text-5xl text-center">
              {elevation.title}
            </h2>
            <span className="mt-5 h-px w-16 bg-neg-gold" />
            <p className="mt-5 text-neg-navy/50 italic text-sm text-center">{elevation.note}</p>
          </div>
        </Reveal>

        <Reveal delay={120}>
          <div className="mt-12 bg-white p-4 sm:p-8 shadow-xl shadow-black/10">
            <img
              src={elevation.image}
              alt="Building elevation"
              className="w-full object-contain"
              loading="lazy"
            />
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Elevation;
